import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import { Box, Button, Divider, IconButton, Tooltip } from '@mui/material';
import ReactPlayer from 'react-player';
import ThumbnailCreatorDialog from './ThumbnailCreatorDialog';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import api from '../../../conf/api';
import { toast } from 'react-toastify';

export default function StyledVideoCard({ video, handleDownload, is_admin, refreshFnc }) {
    const [open, setOpen] = React.useState(false);

    const PostionParser = (pos) => {
        if (video.id === "VIDLoCWKa") {
            if (typeof (pos) === "string") {
                try {
                    const p = JSON.parse(pos);
                    return p;
                } catch (e) {
                    return { x: 0, y: 0 };
                }
            }
        }
    }
    const [display, setDisplay] = React.useState({ thumbnail: false, play: false });
    const [position, setPostions] = React.useState(PostionParser(video.thumbnail_postion));
    const ref = React.useRef(null);

    const UpdateThumbnailPostion = async () => {
        if (!video.thumbnail_url) return;
        const response = await api.patch(`videos/api/${video.id}/`, { thumbnail_postion: JSON.stringify(position) });
        if (response.status = 200) {
            toast.success("Thumbnail postion updated successfully");
            setDisplay(pre => ({ ...pre, thumbnail: false, play: false }));
        } else {
            toast.error("Failed to update thumbnail postion")
        }
    }

    return (
        <>
            <Card variant="outlined" sx={{ width: "100%", borderRadius: 2, height: "100%", transition: "border-color 200ms", "&:hover": { borderColor: "primary.main" }, "@media (prefers-reduced-motion: reduce)": { transition: "none" } }} ref={ref} >
                <CardActionArea sx={{ cursor: "default", display: "flex", justifyContent: "space-between", flexDirection: "column", height: "100%" }}>
                    <Box p={1.5} sx={{ textAlign: "center", width: "100%" }}>
                        <Typography variant="body2" sx={{ mb: 0.5, textAlign: "left" }}>
                            Uploaded by: <strong>{video.username}</strong>{video.category}
                        </Typography>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                            {is_admin && video.downloads.length > 0 && (
                                <Typography variant="subtitle2" noWrap>
                                    Downloaded By:&nbsp;
                                    {video.downloads?.map((u, idx) => (
                                        <React.Fragment key={u.user_email}>
                                            <a href={`mailto:${u.user_email}`} style={{ textDecoration: "underline" }}>
                                                {u.user_email}
                                            </a>
                                            {idx < video.downloads.length - 1 && ', '}
                                        </React.Fragment>
                                    ))}
                                </Typography>
                            )}
                            <Typography variant='caption'>{video.categories?.map((ctg, idx) => (ctg.name)).join(", ")}</Typography>

                        </Box>
                        <Box position="relative" sx={{ cursor: display.thumbnail ? "move" : "pointer" }}>
                            {is_admin &&
                                <Box sx={{ position: "absolute", top: -5, right: -5, zIndex: 1, width: "100%" }} display="flex" justifyContent="space-between" aliginItems="center">
                                    <IconButton aria-label="Set thumbnail" sx={{ width: 44, height: 44 }} onClick={(e) => { e.stopPropagation(); setOpen(true) }}>
                                        <AddPhotoAlternateIcon sx={{ color: !video.thumbnail_url ? "primary.light" : "common.white" }} fontSize='large' />
                                    </IconButton>
                                </Box>
                            }
                            <CardMedia
                                component={ReactPlayer}
                                url={video.dropbox_link?.replace("www.dropbox.com", "dl.dropboxusercontent.com")}
                                controls
                                width="100%"
                                height="100px"
                                playing={display.play}
                                light={!video.thumbnail_url ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMmyTPv4M5fFPvYLrMzMQcPD_VO34ByNjouQ&s" : video.thumbnail_url?.replace("www.dropbox.com", "dl.dropboxusercontent.com")}
                                sx={{
                                    height: "auto !important",
                                    aspectRatio: "16 / 9",
                                    minHeight: 0,
                                    overflow: "hidden",
                                    borderRadius: 2,
                                    bgcolor: "action.hover",
                                    position: "relative",
                                    "& video": {
                                        maxHeight: "100% !important",
                                        borderRadius: 1.25,
                                    },
                                    "& .react-player__preview": {
                                        position: "absolute !important",
                                        top: 0,
                                        y: 1,
                                        height: "100%",
                                        borderRadius: "10px !important",
                                    }

                                }}
                            />


                        </Box>
                    </Box>
                    <CardContent sx={{ pt: 0, textAlign: "left", width: "100%" }}>
                        <Divider variant='middle' flexItem sx={{ mb: .5 }} />
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                            <Typography variant="body2"  >
                                {video.assert_id}
                            </Typography>
                            <Typography variant="body2">
                                Asset ID: <strong>{video.assert_id}</strong>
                            </Typography>
                        </Box>
                        <Typography noWrap variant="subtitle2" component="div">
                            {video.title}
                        </Typography>
                        <Button variant='contained' color='primary' fullWidth sx={{ mt: 1, minHeight: 44 }} size='large' onClick={handleDownload}>Download</Button>
                    </CardContent>
                </CardActionArea>
            </Card >
            <ThumbnailCreatorDialog open={open && is_admin} video={video} setOpen={setOpen} refreshFunc={refreshFnc} />
        </>

    );
}
